import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseAdvertisingManage() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      advertismentID: isEmpty(state.advertismentID),
      contractID: isEmpty(state.contractID),
      startDate: isEmpty(state.startDate),
      endDate: isEmpty(state.endDate),
    };

    setter(errorState);

    if (
      errorState.title ||
      errorState.advertismentID ||
      errorState.contractID ||
      errorState.startDate ||
      errorState.endDate
    ) {
      enqueueSnackbar("لطفا اطلاعات تبلیغ را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getAdvertisingManageList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_AdvertisingManage?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllAdvertisingManageList = (callback) => {
    MyAxios.get(`Admin_AdvertisingManage?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAdvertisingManageByID = (id, callback) => {
    MyAxios.get(`Admin_AdvertisingManage/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateAdvertisingManage = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_AdvertisingManage`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addAdvertisingManage = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_AdvertisingManage`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteAdvertisingManage = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_AdvertisingManage`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getAdvertisingManageList,
    getAllAdvertisingManageList,
    getAdvertisingManageByID,
    validate,
    updateAdvertisingManage,
    addAdvertisingManage,
    deleteAdvertisingManage,
  };
}
